import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardFooter from "../../components/Card/CardFooter.jsx";

import loginPageStyle from "../../assets/jss/material-kit-react/views/loginPage.jsx";

import image from "../../assets/img/bg7.jpg";
import Team from "./Sections/Team";
import getFileData from "../../APICall/Api.jsx";
import Loading from "../../components/Loading/Loading.jsx";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      language: window.language.setLanguage(props.match.params.lang).components,
      isLoaded: false,
      url: getFileData,
      data: {},
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      language: window.language.setLanguage(newProps.match.params.lang)
        .components,
    });
    this.callAPI(newProps.match.params.lang);
  }

  formatText = (text) => {
    let newText = text.split("\n");

    return (
      <div>
        {newText.map((a, i) => (
          <p align="justify">{a}</p>
        ))}
      </div>
    );
  };

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
    this.callAPI(this.props.match.params.lang);
  }

  getTeamSection() {
    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      return <Loading />;
    } else {
      return <Team {...this.state.data} />;
    }
  }

  callAPI = (lang) => {
    fetch(`${this.state.url.getFileData}/Staff${lang.capitalize()}.json`, {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            data: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error,
          });
        }
      );
  };

  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          absolute
          color="transparent"
          brand={this.state.language.title}
          rightLinks={
            <HeaderLinks
              language={this.state.language}
              match={this.props.match}
              history={this.props.history}
            />
          }
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center",
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <Card className={classes[this.state.cardAnimaton]}>
                  <form className={classes.form}>
                    <CardHeader color="primary" className={classes.cardHeader}>
                      <h4>{this.state.language.aboutus.title}</h4>
                      <div className={classes.socialLine}>
                        <Button
                          justIcon
                          href="https://twitter.com/bggroup_al"
                          target="_blank"
                          color="transparent"
                        >
                          <i className={"fab fa-twitter"} />
                        </Button>
                        <Button
                          justIcon
                          href="https://www.facebook.com/Build-Green-Group-118078778536093/"
                          target="_blank"
                          color="transparent"
                        >
                          <i className={"fab fa-facebook"} />
                        </Button>
                        <Button
                          justIcon
                          href="https://www.instagram.com/buildgreenalbania/"
                          target="_blank"
                          color="transparent"
                        >
                          <i className={"fab fa-instagram"} />
                        </Button>
                      </div>
                    </CardHeader>
                    <p className={classes.divider}>
                      {this.state.language.title}
                    </p>
                    <CardBody>
                      {this.formatText(this.state.language.aboutus.text)}
                    </CardBody>
                    <CardFooter className={classes.cardFooter} />
                  </form>
                </Card>
                {this.getTeamSection()}
              </GridItem>
            </GridContainer>
          </div>
          <Footer
            whiteFont
            {...this.state.language}
            match={this.props.match}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(LoginPage);



// WEBPACK FOOTER //
// ./src/views/About Us/AboutUs.jsx